import React from 'react'
import {component_tool} from '@/tool';
import LookQuestionType from './lookQuestionType'
//配置项
let componentName = 'questionType'
let ref;

const columns = (data, parent) => {
    let columnsRef = []
    columnsRef = columnsRef.concat([
      {
        name: "id",
        formItem: {
          type: "hidden"
        }
      },
      {
        name: "type",
        searchItem: {
          type: "hidden",
        },
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createBy",
        formItem: {
          type: "hidden",
        }
      },
      {
        name: "createTime",
        formItem: {
          type: "hidden",
        }
      },
    ])
    if (parent !== 'no') {
      columnsRef = columnsRef.concat([
        {
          title: "上级分类",
          name: "parentId",
          dataIndex: "parentId",
          dict: {
            wizReplaceData: "treeData",
            defalutType: []
          },
          formItem: {
            type: 'treeselect',
            allowClear: true,
          },
        }
      ])
    }
    columnsRef = columnsRef.concat([
      {
        title: "分类名称",
        name: "name",
        dataIndex: "name",
        formItem: {
          maxlength: 40,
          placeholder: '分类名称最多输入40个字',
          rules: [
            {
              required: true,
              message: '请输入分类类型名称'
            },
            {
              pattern: /^[^\s]*$/,
              message: '分类类型名称录入信息不能包含空格'
            }
          ],
        },
        searchItem: {},
        tableItem: {}
      },
    ])
    if (parent !== 'no') {
      columnsRef = columnsRef.concat([
        {
          title: "上级分类",
          name: "parentName",
          dataIndex: "parentName",
          tableItem: {}
        },])
    }
    columnsRef = columnsRef.concat([
      {
        title: "简介",
        name: "intro",
        dataIndex: "intro",
        tableItem: {
          width: 260,
        },
        formItem: {
          type: 'textarea',
          placeholder: '请输入简介,最多100字',
          maxlength: 100,
        },
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {},
        dict: [
          {code: 1, codeName: "有效"},
          {code: 0, codeName: "无效"}
        ],
        searchItem: {
          type: "select"
          // mode: 'multiple',
        },
        formItem: {
          type: "select",
          initialValue: 1
        }
      }])
    return columnsRef
  }
;

const templateConfig = (data) => {
  const {type, parent, pathname} = data;
  const columnsInfo = columns(type, parent);
  let returnObj = {
      name: "WizTableList",
      params: {
        columns: columnsInfo,
        searchBarProps: {
          collapse: false,
          buttonSort: ['add', 'delete'],
          buttons: [
            // {
            //   key: 'export',
            //   custom: true,
            //   params: {icon: "export", children: "导出", type: "export"},
            //   customOnClick: {
            //     key: 'action',
            //     params: {
            //       apiKey: "export",
            //       apiParams: {}
            //     },
            //     formatParams: (rows, record, filters, callback) => {
            //       return {...filters}
            //     }
            //   }
            // },
            // {
            //   key: 'import',
            //   custom: true,
            //   params: {icon: 'import', children: '批量导入', type: 'import'},
            //   customOnClick: {
            //     key: 'jumpPage',
            //     params: {
            //       key: 'push',
            //       pathname: `${pathname}/fileImport`,
            //       record: {type: type}
            //     }
            //   },
            // }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['look', 'update'],
        commonOperate: {
          add: true,
          update: true,
          delete: true,
          look: false
        },
        rowOperateView: [
          type == '2' ? {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "questionTypeLook",
                modalParams: {
                  title: "查看题目分类",
                  cancelButtonProps: {style: {height: 0, width: 0}},
                  style: {minWidth: 700},
                  footer: null,
                  diy: (e) => {
                    return (
                      <LookQuestionType
                        key={'questionTypeLook' + e.record.id}
                        {...e}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },
                  onOk: () => {
                    ref._ok();
                  },
                  width: 600
                },
              }
            }
          } : {},
          // {
          //   key: "power",
          //   custom: true,
          //   params: {children: "权限管理"},
          //   customOnClick: {
          //     key: "jumpPage",
          //     params: {
          //       key: 'push',
          //       pathname: `${pathname}/auth`,
          //       record: {type: type}
          //     }
          //   }
          // }
        ]
      }
  }
  if (parent !== 'no') {
    returnObj.params.siderBarProps ={
        key: "nodeTree",
        searchKey: "id",
        params: {type}
    }
  }
  return {
    mainProps: {},
    content:returnObj
  }
};


let reduxTemplateCofig = (args) => {
  const {type, parent,filterId,id} = args;
  const apis = {
    list: {
      path: `${componentName}/${type === '2' ? 'normalListByPage' : 'listByPageNew'}`,
      payload: {
        key: `${componentName}@listByPageNew`,
        apiParams: {pageNum: 1, pageSize: 10, type,filterId,id}
      }
    },

    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {type}
      }
    },
    treeData: {
      path: `${componentName}/${type === '2' ? 'normalNodeList' : 'nodeList'}`,
      payload: {
        key: `${componentName}@treeData`,
        apiParams: {type,id}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {type,parentId:filterId}
      }
    },
    update: {
      path: `${componentName}/upd`,
      payload: {
        key: `${componentName}@upd`,
        apiParams: {type,parentId:filterId}
      }
    },
    delete: {
      path: `${componentName}/del`,
      payload: {
        key: `${componentName}@del`,
        apiParams: {type}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    }
  };
  return {
    apis,
    componentName,
    initApiKeys: ['list', 'treeData'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
